"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const m = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S16.825 3.25 12 3.25M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-4.47a1 1 0 0 1-1-1v-5.565a1 1 0 1 1 2 0v5.565a1 1 0 0 1-1 1m-.837-8.993q.363.315.848.315.47 0 .829-.318.36-.319.359-.878 0-.5-.341-.844a1.16 1.16 0 0 0-.847-.343q-.51 0-.86.342a1.14 1.14 0 0 0-.351.846q0 .567.363.88",
        clipRule: "evenodd"
      }
    )
  }
), a = l(m);
export {
  a as Info,
  a as default
};
